import { render, staticRenderFns } from "./selectSkuCom.vue?vue&type=template&id=2ad6dc4e&scoped=true"
import script from "./selectSkuCom.vue?vue&type=script&lang=js"
export * from "./selectSkuCom.vue?vue&type=script&lang=js"
import style0 from "./selectSkuCom.vue?vue&type=style&index=0&id=2ad6dc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6dc4e",
  null
  
)

export default component.exports